import Menu from "./modules/menu";
import Theme from "./modules/theme";
import Faq from "./modules/faq";
import LoadMore from "./modules/loadMore";
import Slider from "./modules/slider";
import PriceSlider from "./modules/priceSlider";
import InputNumber from "./modules/inputNumber";
import Woocommerce from "./modules/woocommerce";
import DeliveryPrice from "./modules/deliveryPrice";
import SingleGallery from "./modules/singleGallery";
import PopularSlider from "./modules/popularSlider";

Menu.init();
Theme.init();
Faq.init();
LoadMore.init();
PriceSlider.init();
Slider.init();
Woocommerce.init();
InputNumber.init();
DeliveryPrice.init();
SingleGallery.init();
PopularSlider.init();

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

if (isSafari) {
  document.documentElement.classList.add("safari");
}

jQuery(document).ready(function ($) {
  $("input.timepicker").timepicker({
    timeFormat: "HH:mm",
    interval: 60,
    minTime: "10:00",
    maxTime: "21:00",
    startTime: "10:00",
    dynamic: true,
    dropdown: true,
    scrollbar: true,
  });
});

jQuery(document).ready(function ($) {
  function moveWapfIntoForm() {
    var wapf = $(".wapf");
    var form = $(".variations .value ");

    if (wapf.length) {
      wapf.appendTo(form);
    }
  }

  moveWapfIntoForm();

  const maxSelections = 2;

  $(document).on("change", '.wapf input[type="checkbox"]', function () {
    const name = $(this).attr("name");
    const $checkboxGroup = $('input[name="' + name + '"]');
    const checkedCount = $checkboxGroup.filter(":checked").length;

    if (checkedCount > maxSelections) {
      this.checked = false;
      alert("Možete izabrati najviše " + maxSelections + " opcije.");
      return;
    }

    // Ako je dostignut max broj selekcija, disable ostale koje nisu čekirane
    if (checkedCount === maxSelections) {
      $checkboxGroup.not(":checked").prop("disabled", true);
    } else {
      // Omogući sve checkboxove ako nije dostignut maksimum
      $checkboxGroup.prop("disabled", false);
    }
  });

  jQuery(function ($) {
    $(".wapf-field-label label span").each(function () {
      const text = $(this).text();
      if (!text.endsWith(":")) {
        $(this).text(text + ":");
      }
    });

    const observer = new MutationObserver(() => {
      $(".woo-selected-variation-item-name").each(function () {
        let text = $(this).text().trim();
        text = text.replace(/^:\s*/, "");
        if (!text.endsWith("rsd")) {
          $(this).text(text + " rsd");
        }
      });
    });

    if (document.querySelector("form.variations_form")) {
      observer.observe(document.querySelector("form.variations_form"), {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  });

  $(document.body).on(
    "woocommerce_update_variation_values woocommerce_variation_has_changed",
    function () {
      moveWapfIntoForm();
    }
  );
});

lightbox.option({
  wrapAround: true, // Omogućava kružno kretanje kroz slike, strelice su stalno dostupne
  showImageNumberLabel: false,
  positionFromTop: 139,
  albumLabel: false,
  disableScrolling: true,
  // ... ostale opcije
});

const items = document.querySelectorAll(".slider-content--item-inner");

class LightBoxVideo {
  constructor() {
    this.videos = {};
    this.lightBoxVideo();
  }

  lightBoxVideo = () => {
    this.setEvents();
    this.setMutationObserver();
  };

  setMutationObserver = () => {
    const observer = new MutationObserver((mutation) => {
      const imageMutations = mutation.filter((m) => {
        return m.attributeName === "src" && m.target.className === "lb-image";
      });

      const overlayDisplay = window.getComputedStyle(
        document.querySelector(".lightboxOverlay"),
        null
      ).display;
      if ("none" === overlayDisplay) {
        this.removeVideoElement();
      }

      if (imageMutations.length > 0) {
        if (this.videos[imageMutations[0].target.src]) {
          this.removeVideoElement();
          this.setVideoElement(this.videos[imageMutations[0].target.src]);
        }
      }
    });

    observer.observe(document.body, {
      childList: false,
      attributes: true,
      subtree: true,
      characterData: false,
    });
  };

  setEvents = () => {
    const videoLinks = this.findVideoLinks();
    videoLinks.forEach((link) => {
      this.videos[link.href] = link;
      link.addEventListener("click", (e) => {
        e.preventDefault(); // <== najvažnije
        this.removeVideoElement();
        this.setVideoElement(e.target);
      });
    });
  };

  setVideoElement = (element) => {
    const lightbox = document.querySelector(".lightbox");
    const container = lightbox.querySelector(".lb-container");
    lightbox.classList.add("video-lightbox");

    this.removeVideoElement();

    const videoElement = this.createVideoElement(element);
    setTimeout(() => {
      container.prepend(videoElement);
    }, 100);
    setTimeout(() => {
      const lightboxVideo = document.querySelector(".lightbox video");
      const windowHeight = window.innerHeight / 2;
      const height = lightboxVideo.offsetHeight / 2;
      const scrollPosition = window.scrollY;

      lightbox.style.top = `${scrollPosition + windowHeight - height}px`;
      lightbox.querySelector(".animating").classList.remove("animating");
      lightbox.querySelector(".lb-loader").style.display = "none";
    }, 300);
  };

  removeVideoElement = () => {
    const lightbox = document.querySelector(".lightbox");
    const container = lightbox.querySelector(".lb-container");
    const video = container.querySelector("video");

    if (video) {
      container.removeChild(video);
    }
  };

  createVideoElement = (element) => {
    const video = document.createElement("video");

    // video.setAttribute('poster', element.href);
    video.setAttribute("controls", "true");
    video.setAttribute("autoplay", "autoplay");
    video.setAttribute("playsinline", ""); // VAŽNO
    video.setAttribute("webkit-playsinline", ""); // VAŽNO za stariji iOS Safari

    const source = document.createElement("source");
    source.setAttribute("src", element.dataset.href);
    source.setAttribute("type", "video/mp4");

    video.append(source);

    return video;
  };

  findVideoLinks = () => {
    const hrefs = document.querySelectorAll("a[data-lightbox]");
    const regex = /\.(mp4|mov|flv|wmv)$/;
    if (0 === hrefs.length) {
      return [];
    }
    return Array.from(hrefs).filter((href) => {
      return !!href.dataset.href.match(regex);
    });
  };
}

window.addEventListener("DOMContentLoaded", () => {
  new LightBoxVideo();
});
